import { TranslateService } from "@ngx-translate/core";

export enum UserTypeEnum {
  Staff = 30,
  Guardian = 20,
  Student= 10,
  Guest = 40
}

export namespace UserTypeEnum {
  export function toStringTranslated(userType: UserTypeEnum, translate: TranslateService): string {
    switch (userType) {
      case UserTypeEnum.Staff:
        return translate.instant('userType.Staff');
      case UserTypeEnum.Guardian:
        return translate.instant('userType.Guardian');
      case UserTypeEnum.Student:
        return translate.instant('userType.Student');
      case UserTypeEnum.Guest:
        return translate.instant('userType.Guest');
      default:
        return translate.instant('Unknown');
    }
  }

  export function toString(userType: UserTypeEnum): string {
    switch (userType) {
      case UserTypeEnum.Staff:
        return "Staff";
      case UserTypeEnum.Guardian:
        return "Guardian";
      case UserTypeEnum.Student:
        return "Student";
      case UserTypeEnum.Guest:
        return "Guest";
      default:
        return "Unknown";
    }
  }
}